import "./BuildBadge.css";

/** "Which build is this venue actually running?" — answered from the app itself, unobtrusively. */
export function BuildBadge(): React.JSX.Element {
  return <div className="build-badge">{__BUILD_ID__}</div>;
}
